// @spec BCP-STR-057
// @spec BCP-STR-032
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { BCPReviewSettingsCard, ExerciseRequirementsCard } from '@/features/settings/bcp';
import { useOrgRole } from '@/hooks/use-org-role';
import i18n from '@/lib/i18n';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/settings/bcp-review-settings')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.bcpReviewSettings'),
  }),
  component: BCPReviewSettingsPage,
});

/**
 * Organization BCP review settings page for configuring review frequencies
 * and exercise requirements.
 *
 * Allows organization admins to:
 * - Configure review frequencies per plan type
 * - Set criticality-based frequency overrides
 * - Configure reminder lead times and escalation
 * - Enable/disable automatic review task creation
 * - Configure exercise testing frequency requirements
 * - Set exercise alert and escalation settings
 */
function BCPReviewSettingsPage() {
  const { t } = useTranslation('settings');
  const { isAdmin } = useOrgRole();

  return (
    <div className="p-8">
      <div className="mx-auto max-w-4xl space-y-8">
        <header>
          <h1 className="text-3xl font-semibold text-foreground">
            {t('bcpReviewSettingsPage.title')}
          </h1>
          <p className="mt-1 text-muted-foreground">{t('bcpReviewSettingsPage.description')}</p>
        </header>

        <section className="space-y-6">
          <BCPReviewSettingsCard isAdmin={isAdmin} />
          <ExerciseRequirementsCard isAdmin={isAdmin} />
        </section>
      </div>
    </div>
  );
}
